// Mirror of backend-nest/src/agents/constants/customizable-agents.ts.
//
// The backend gates BOTH persistence (OnboardingApplyService.upsertAgentConfiguration)
// and prompt composition (PromptComposerService.composeAround) on this exact set.
// Any agent type outside it silently discards whatever the user typed, so the UI
// must not offer a custom-instructions editor for one. Keep the two lists in step —
// customizable-agents.test.ts pins the membership on this side, and the backend
// spec of the same name pins it on the other.
export const CUSTOMIZABLE_AGENT_TYPES: ReadonlySet<string> = new Set<string>([
  'lead_qualification',
  'lead_enrichment',
  'follow_up_scheduler',
  'sentiment_analysis',
  'prompt_enricher',
  'linkedin_company_research',
  'browser_company_research',
  'instagram_company_research',
]);

export function isCustomizableAgent(type: string): boolean {
  return CUSTOMIZABLE_AGENT_TYPES.has(type);
}
